import { useCallback } from 'react'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'

interface ModalEditOrderCurrencyProps extends ModalEditOrderCurrencyLogicProps {
    Currency: string
}

const ModalEditOrderCurrency: React.FC<ModalEditOrderCurrencyProps> = ({Currency, ...logic}) => {
    const { t, tVars} = useTwinTranslation()
    const options = { Currency}
    const { confirmChangeCurrency } = useModalEditOrderCurrencyLogic({...logic})

    return (
        <ModalSmallFilled translations={{
            title: t('changeOfCurrency', 'Cambio de moneda'),
            subtitle: tVars('sureChangeOfCurrencyRecalculateAllPrices', '¿Estás seguro de cambiar la moneda a {{Currency}} y recalcular todos los precios?', options),
            buttonAccept: t('accept', 'Aceptar'),
        }} onAccept={confirmChangeCurrency} opened={true} setOpened={logic.setOpened} onClickOut={false} />
    )
}

interface ModalEditOrderCurrencyLogicProps extends ModalEditComponentProps {
    updateCurrencyURL: string
    id: number
}

const useModalEditOrderCurrencyLogic = ({ updateCurrencyURL, id, allRowData, onSubmit }: ModalEditOrderCurrencyLogicProps) => {
    
    const confirmChangeCurrency = useCallback(async () => {
        const res = await twinFetchPostJSON(updateCurrencyURL, { id, CurrencyId: allRowData?.CurrencyId})
        await onSubmit?.(res, {})
    }, [updateCurrencyURL, id, allRowData?.CurrencyId, onSubmit])

    return { confirmChangeCurrency }
}

export default ModalEditOrderCurrency